import { Trans } from "@lingui/macro";
import { faqDetails } from "./faq-details";
import { Disclosure } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";

const FAQSection: React.FunctionComponent = () => {
  return (
    <div className="mx-auto max-w-7xl grid-cols-3 gap-4 px-6 md:grid">
      <div className="w-full pt-16">
        <p className="pl-2 font-poppins text-xl font-bold text-text-darkest">
          <Trans>⚙️ General</Trans>
        </p>
        <div className="mx-auto w-full max-w-md rounded-2xl bg-white p-2">
          {faqDetails[0].map((detail) => (
            <Disclosure key={detail.key + Math.random()}>
              {({ open }) => (
                <>
                  <Disclosure.Button className="flex w-full justify-between border-b-2 border-off-white py-2 text-left font-sen text-text-darkest">
                    <span className="w-72">{detail.title}</span>
                    <ChevronDownIcon
                      className={`${
                        open ? "rotate-180 transform" : ""
                      } h-5 w-5 text-primary`}
                    />
                  </Disclosure.Button>
                  <Disclosure.Panel className="pt-4 pb-2 font-sen text-text-medium">
                    {detail.answer}
                  </Disclosure.Panel>
                </>
              )}
            </Disclosure>
          ))}
        </div>
      </div>
      <div className="w-full pt-16">
        <p className="pl-2 font-poppins text-xl font-bold text-text-darkest">
          <Trans>🔒 Account Preferences</Trans>
        </p>
        <div className="mx-auto w-full max-w-md rounded-2xl bg-white p-2">
          {faqDetails[1].map((detail) => (
            <Disclosure key={detail.key + Math.random()}>
              {({ open }) => (
                <>
                  <Disclosure.Button className="flex w-full justify-between border-b-2 border-off-white py-2 text-left font-sen text-text-darkest">
                    <span className="w-72">{detail.title}</span>
                    <ChevronDownIcon
                      className={`${
                        open ? "rotate-180 transform" : ""
                      } h-5 w-5 text-primary`}
                    />
                  </Disclosure.Button>
                  <Disclosure.Panel className="pt-4 pb-2 font-sen text-text-medium">
                    {detail.answer}
                  </Disclosure.Panel>
                </>
              )}
            </Disclosure>
          ))}
        </div>
      </div>
      <div className="w-full pt-16">
        <p className="pl-2 font-poppins text-xl font-bold text-text-darkest">
          <Trans>🔑 User Profiles</Trans>
        </p>
        <div className="mx-auto w-full max-w-md rounded-2xl bg-white p-2">
          {faqDetails[2].map((detail) => (
            <Disclosure key={detail.key + Math.random()}>
              {({ open }) => (
                <>
                  <Disclosure.Button className="flex w-full justify-between border-b-2 border-off-white py-2 text-left font-sen text-text-darkest">
                    <span className="w-72">{detail.title}</span>
                    <ChevronDownIcon
                      className={`${
                        open ? "rotate-180 transform" : ""
                      } h-5 w-5 text-primary`}
                    />
                  </Disclosure.Button>
                  <Disclosure.Panel className="pt-4 pb-2 font-sen text-text-medium">
                    {detail.answer}
                  </Disclosure.Panel>
                </>
              )}
            </Disclosure>
          ))}
        </div>
      </div>
      <div className="w-full pt-16">
        <p className="pl-2 font-poppins text-xl font-bold text-text-darkest">
          <Trans>🔔 Notifications</Trans>
        </p>
        <div className="mx-auto w-full max-w-md rounded-2xl bg-white p-2">
          {faqDetails[3].map((detail) => (
            <Disclosure key={detail.key + Math.random()}>
              {({ open }) => (
                <>
                  <Disclosure.Button className="flex w-full justify-between border-b-2 border-off-white py-2 text-left font-sen text-text-darkest">
                    <span className="w-72">{detail.title}</span>
                    <ChevronDownIcon
                      className={`${
                        open ? "rotate-180 transform" : ""
                      } h-5 w-5 text-primary`}
                    />
                  </Disclosure.Button>
                  <Disclosure.Panel className="pt-4 pb-2 font-sen text-text-medium">
                    {detail.answer}
                  </Disclosure.Panel>
                </>
              )}
            </Disclosure>
          ))}
        </div>
      </div>
      <div className="w-full pt-16">
        <p className="pl-2 font-poppins text-xl font-bold text-text-darkest">
          <Trans>💬 Chat, Comments, and Community</Trans>
        </p>
        <div className="mx-auto w-full max-w-md rounded-2xl bg-white p-2">
          {faqDetails[4].map((detail) => (
            <Disclosure key={detail.key + Math.random()}>
              {({ open }) => (
                <>
                  <Disclosure.Button className="flex w-full justify-between border-b-2 border-off-white py-2 text-left font-sen text-text-darkest">
                    <span className="w-72">{detail.title}</span>
                    <ChevronDownIcon
                      className={`${
                        open ? "rotate-180 transform" : ""
                      } h-5 w-5 text-primary`}
                    />
                  </Disclosure.Button>
                  <Disclosure.Panel className="pt-4 pb-2 font-sen text-text-medium">
                    {detail.answer}
                  </Disclosure.Panel>
                </>
              )}
            </Disclosure>
          ))}
        </div>
      </div>
      <div className="w-full pt-16">
        <p className="pl-2 font-poppins text-xl font-bold text-text-darkest">
          <Trans>🏠 For You tab</Trans>
        </p>
        <div className="mx-auto w-full max-w-md rounded-2xl bg-white p-2">
          {faqDetails[5].map((detail) => (
            <Disclosure key={detail.key + Math.random()}>
              {({ open }) => (
                <>
                  <Disclosure.Button className="flex w-full justify-between border-b-2 border-off-white py-2 text-left font-sen text-text-darkest">
                    <span className="w-72">{detail.title}</span>
                    <ChevronDownIcon
                      className={`${
                        open ? "rotate-180 transform" : ""
                      } h-5 w-5 text-primary`}
                    />
                  </Disclosure.Button>
                  <Disclosure.Panel className="pt-4 pb-2 font-sen text-text-medium">
                    {detail.answer}
                  </Disclosure.Panel>
                </>
              )}
            </Disclosure>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQSection;
